import { splitProps } from "solid-js";
import { TitleProps } from "./model";

export function Title(props:TitleProps){
      const [local,others] = splitProps(props,["children","bold","classes"])
      const {bold, classes, children} = local

      return <h1  class={`text-25px ${bold && 'font-bold'} leading-28px ${classes}`}>{children}</h1>
}